import React from 'react';

import { useIntl } from 'ha/i18n';
import {
  RegistrationFilterValue,
  RegistrationFilterCount,
} from 'ha/types/SearchFilters';

import { CommonCheckboxFilter } from './CommonCheckboxFilter';
import { CommonCheckboxTitleWithCount } from './CommonCheckboxTitleWithCount';

interface Props {
  value: RegistrationFilterValue;
  onChange: (value: RegistrationFilterValue) => void;
  count?: RegistrationFilterCount;
}

const RegistrationFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      value={value}
      onChange={onChange}
      options={[
        {
          value: 'possible',
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Possible')}
              count={count?.possible}
            />
          ),
          testLocator: 'Filter Registration Possible',
        },
      ]}
    />
  );
};

export { RegistrationFilter };
